<template>
  <div class="tw-p-4">
    <div>
      <GameSearch @onSearchText="search = $event" @search="searchData(null, true)" :showNavLabel="false"></GameSearch>
    </div>
    <div class="tw-flex tw-items-center tw-space-x-3 tw-mb-5">
      <v-btn
        @click="sort_name = 'home_sort_order'"
        class="tw-rounded-xl"
        :color="`${sort_name == 'home_sort_order' ? '#2b57fb' : '#0a356b'}  `"
        ><strong>Home Sort</strong></v-btn
      >

      <v-btn
        @click="sort_name = 'provider_sort_order'"
        class="tw-rounded-xl"
        :color="`${sort_name == 'provider_sort_order' ? '#2b57fb' : '#0a356b'}  `"
        ><strong>Provider Sort</strong></v-btn
      >
      <v-btn
        @click="sort_name = 'sort_order'"
        class="tw-rounded-xl"
        :color="`${sort_name == 'sort_order' ? '#2b57fb' : '#0a356b'}  `"
        ><strong>Slot Sort</strong></v-btn
      >

      <v-btn
        @click="sort_name = 'live_sort_order'"
        class="tw-rounded-xl"
        :color="`${sort_name == 'live_sort_order' ? '#2b57fb' : '#0a356b'}  `"
        ><strong>Live Sort</strong></v-btn
      >
    </div>
    <div
      class="tw-w-full tw-flex tw-items-center tw-flex-wrap tw-justify-between tw-mb-5"
      v-if="sort_name == 'provider_sort_order'"
    >
      <div class="tw-flex tw-items-center tw-space-x-3">
        <v-select
          class="tw-w-48"
          color="#C2C2C2"
          item-color="#C2C2C2"
          v-model="selected_provider"
          :items="provider"
          label="Provider"
          hide-details
          dark
          outlined
          dense
          rounded
        ></v-select>
      </div>
    </div>
    <div class="tw-grid tw-grid-cols-8 tw-gap-2 tw-font-bold tw-border-b tw-border-gray-600 tw-pb-2 tw-mb-2">
      <div></div>
      <div class="tw-text-left">Order #</div>
      <div class="tw-px-2">Image</div>
      <div class="tw-col-span-2 tw-text-left">Name</div>
      <div class="tw-col-span-2">Provider</div>
      <div class="tw-text-left">Type</div>
    </div>
    <draggable v-model="games" @change="onChange" item-key="uuid" handle=".handle" v-bind="dragOptions">
      <transition-group
        class="tw-grid tw-grid-cols-1 tw-gap-2 tw-max-h-[1100px] tw-overflow-y-scroll"
        type="transition"
        :name="!drag ? 'flip-list' : null"
      >
        <div
          v-for="game in games"
          :key="game.uuid"
          class="tw-text-white tw-bg-[#031b41] tw-w-full tw-grid tw-grid-cols-8"
        >
          <div class="tw-flex tw-items-center tw-justify-start tw-ml-2">
            <v-btn color="#031b41" dark class="handle">
              <v-icon>mdi-drag</v-icon>
            </v-btn>
          </div>

          <div class="tw-flex tw-items-center tw-justify-start">
            <div class="tw-flex tw-items-center tw-space-x-4">
              <span>#</span>
              <v-text-field
                single-line
                dense
                :value="game[sort_name]"
                @blur="updateValue($event, game, sort_name)"
                @keyup.enter="updateValue($event, game, sort_name)"
                hide-details
                color="inherit"
                outlined
                label="Search"
                class="tw-w-full tw-rounded-xl"
              ></v-text-field>
            </div>
          </div>
          <div class="tw-flex tw-items-center tw-justify-start tw-px-2">
            <v-img
              :class="`tw-flex tw-items-end ${game.saved ? 'tw-border-4 shadow tw-border-[#2b57fb]' : ''}`"
              :src="game.image"
              height="50"
            ></v-img>
          </div>
          <div class="tw-col-span-2 tw-flex tw-items-center tw-justify-start">{{ game.name }}</div>
          <div class="tw-col-span-2 tw-flex tw-items-center tw-justify-center">
            <div>
              <div>{{ game.main_provider }}</div>
              <div class="tw-text-xs tw-text-gray-400">{{ game.provider }}</div>
            </div>
          </div>
          <div class="tw-flex tw-items-center tw-justify-center">{{ game.type }}</div>
        </div>
      </transition-group>
    </draggable>
    <div class="tw-flex tw-items-center tw-justify-center tw-mt-5" v-if="games.length < totalGames">
      <v-btn color="#2b57fb" dark @click="loadMore">Load More</v-btn>
    </div>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import { mapActions } from "vuex";
import GameSearch from "../../../components/GameSearch.vue";
import gameApi from "../../../api/gameApi";
export default {
  name: "GameList",
  components: {
    draggable,
    GameSearch,
  },
  computed: {
    dragOptions() {
      return {
        animation: 200,
        group: "games",
        disabled: false,
        ghostClass: "ghost",
      };
    },
  },
  data() {
    return {
      sort_name: "home_sort_order",
      search: "",
      provider: [],
      selected_provider: "",
      curPage: 1,
      limit: 30,
      games: [],
      drag: false,
      totalGames: 0,
    };
  },
  mounted() {
    this.fetchGames();
    this.getProvider();
  },
  watch: {
    sort_name() {
      this.limit = 30;
      this.fetchGames();
    },
    selected_provider() {
      this.limit = 30;
      this.fetchGames();
    },
    search() {
      if (this.search == "") {
        this.limit = 30;
        this.fetchGames();
      }
    },
  },
  methods: {
    ...mapActions("game", ["adminFilterProviders"]),
    async fetchGames() {
      try {
        this.curPage = 1;
        const res = await gameApi.get("/admin/games/displayed", {
          params: {
            search: this.search,
            offset: (this.curPage - 1) * this.limit,
            limit: this.limit,
            sort_name: this.sort_name,
            sort_direction: "asc",
            selected_provider: this.selected_provider,
          },
        });
        this.games = res.data.rows;
        this.totalGames = res.data.count;
      } catch (err) {
        console.log(err);
      }
    },
    async loadMore() {
      this.curPage++;
      try {
        const res = await gameApi.get("/admin/games/displayed", {
          params: {
            offset: (this.curPage - 1) * this.limit,
            limit: this.limit,
            sort_name: this.sort_name,
            sort_direction: "asc",
            selected_provider: this.selected_provider,
          },
        });
        this.games = [...this.games, ...res.data.rows];
        this.limit += res.data.rows.length;
        this.totalGames = res.data.count;
      } catch (err) {
        console.log(err);
      }
    },
    async getProvider() {
      const provider = await this.adminFilterProviders();
      provider.map((obj) => {
        let capitalized = obj.provider.replace(/^./, obj.provider[0].toUpperCase());
        this.provider.push(capitalized);
      });
    },
    formatTime(time) {
      return new Date(time).toLocaleString();
    },
    async onChange(evt) {
      const type = Object.keys(evt)[0];
      const data = evt[type];
      switch (type) {
        case "added":
          this.onChangeSortOrder("added", data);
          break;
        case "moved":
          this.onChangeSortOrder("moved", data);
          break;
        default:
          break;
      }
    },

    updateValue(evt, game, field) {
      const value = Math.max(Number(evt.target.value) - 1, 0);
      const oldIndex = Math.max(game[field] - 1, 0);
      game[field] = value;
      this.onChangeSortOrder("moved", { element: game, newIndex: value, oldIndex: oldIndex });
    },

    async onChangeSortOrder(type, data) {
      try {
        const res = await gameApi.post(`/admin/games/displayed/sort/${type}`, {
          ...data,
          sort_name: this.sort_name,
          selected_provider: this.selected_provider,
        });
        this.fetchGames();
      } catch (err) {
        console.log(err);
      }
    },
    searchData() {
      this.limit = 30;
      this.fetchGames();
    },
  },
};
</script>
